import {
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { GetSiteInfo } from "../../api/api";

type GetCurtailDataProps = {
  authToken: string;
  siteName?: string;
};

type curtailData = {
  source: string;
  id: string;
  rampup_time: number;
  start_time: string;
  end_time: string;
  target_power_usage: number;
};

type CurtailDataResult = {
  status: string;
  curtailSchedule: curtailData[];
};

export const useGetCurtailData = (
  options: GetCurtailDataProps
): UseQueryResult<CurtailDataResult, Error> => {
  const { authToken, siteName } = options;
  return useQuery({
    queryKey: ["curtailData", siteName],
    queryFn: ({ queryKey }) =>
      GetSiteInfo(
        authToken,
        { siteName: siteName },
        "siteCurtailData"
      ),
    enabled: !!authToken && !!siteName,
    staleTime: 0,
    notifyOnChangeProps: "all",
  });
};
